// 是否要啟用開關
const tbdFlags = Object.freeze({
  29807: window.runtimeConfig[29807] || false,
});

export default tbdFlags;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/utils/tbdFlags.js
 **/